export const MAX_VOICE_LINE_LENGTH = 500;
export const MAX_SYNTH_VOICES_PER_PAGE = 25;
export const MAX_VOICE_LINES_PER_PAGE = 50;

export type DownloadTypes = 'ZIP' | 'MERGED';
